import { ApiConfig } from './api';
import { fetchWrapper } from './utils/http-utils';
import { gzip } from '../libs';
import { EmbedChartData } from '../types/analysis';

export const embed =
  (config: ApiConfig) =>
  (data: { widget_key: string; data: EmbedChartData }): Promise<boolean> => {
    const compressed = gzip(JSON.stringify(data));

    return fetchWrapper<boolean>(
      `${config.endpoint}embed_widget`,
      {
        method: 'POST',
        body: compressed,
        headers: {
          'Content-Type': 'application/octet-stream+json',
          'Content-Encoding': 'identity',
          'Gzip-Encoded': 'true',
          'Content-Length': compressed.length.toString(),
        },
      },
      config
    );
  };

export const loadData =
  (config: ApiConfig) =>
  (widget_key: string): Promise<string> =>
    fetchWrapper<string>(
      `${config.embeddedWidgets}/${widget_key}`,
      {
        method: 'GET',
      },
      config
    );
